<template>
  <div>
    <aside class="menu-sidebar d-lg-block">
      <div class="logo">
        <a href="/">
          <img alt="" src="/images/logo.png" class="sidebar-logo" />
        </a>
        <!--b-dropdown :text="'Services'" class="services-dropdown" right variant="link">
          <b-dropdown-item @click.prevent="changeProject(1)">
            <a :class="linkClass(1)" href="javascript:void(0)">
              <i class="fa fa-globe p-r-20"></i>CDN
            </a>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="changeProject(2)">
            <a :class="linkClass(2)" href="javascript:void(0)">
              <i class="fa fa-file-video p-r-25"></i>File Transcoding
            </a>
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="changeProject(3)">
            <a :class="linkClass(3)" href="javascript:void(0)">
              <i class="fa fa-play-circle p-r-20"></i>Live Transcoding
            </a>
          </b-dropdown-item>
        </b-dropdown-->
      </div>

      <div class="menu-sidebar__content">
        <nav class="navbar-sidebar">

          <v-list class="m0 p0">
            <v-list-group
              v-for="item in items"
              :key="item.title"
              :value="currentProject === item.projectCode"
              no-action
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon right :class="{'pa2': item.action === 'fa-file-video' }">
                      {{ item.action }}
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ text(item.title) }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-list-tile
                :class="{ 'primary--text': subItem.components.includes(currentRoute) }"
                v-for="subItem in item.items"
                :key="subItem.title"
                @click="goTo(subItem.route)">
                <v-list-tile-content>
                  <v-list-tile-title>{{ text(subItem.title) }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon :class="{ 'primary--text': subItem.components.includes(currentRoute) }">
                    {{ subItem.action }}
                  </v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </nav>
      </div>

      <!--component :is="currentComponent"></component-->
    </aside>
  </div>
</template>

<script>
import { STORE_TYPES } from '@/store/modules/types';

// import CDNSidebar from '@/components/cdn/sidebar/Sidebar.vue';
// import FileTranscodingSidebar from '@/components/transcoding/file/sidebar/Sidebar.vue';
// import LiveTranscodingSidebar from '@/components/transcoding/live/sidebar/Sidebar.vue';

const projectIndex = {
  1: STORE_TYPES.PROJECT_CODE.CDN,
  2: STORE_TYPES.PROJECT_CODE.FILE_TRANSCODING,
  3: STORE_TYPES.PROJECT_CODE.LIVE_TRANSCODING,
  4: STORE_TYPES.PROJECT_CODE.DVR,
};

const routes = {
  1: 'CDNDashboard',
  2: 'FileTranscodingDashboard',
  3: 'LiveTranscodingDashboard',
  4: 'DVRListPage',
};

export default {
/*  components: {
    CDNSidebar,
    FileTranscodingSidebar,
    LiveTranscodingSidebar,
  }, */
  data() {
    return {
      items: [
        {
          action: 'fa-globe',
          title: 'CDN',
          projectCode: STORE_TYPES.PROJECT_CODE.CDN,
          items: [
            {
              title: 'New Endpoint',
              action: 'add',
              route: 'EndpointNewPage',
              components: ['EndpointNewPage'],
            },
            {
              title: 'Dashboard',
              action: 'dashboard',
              route: 'CDNDashboard',
              components: ['CDNDashboard'],
            },
            {
              title: 'Endpoints',
              action: 'view_list',
              route: 'EndpointListPage',
              components: ['EndpointListPage', 'EndpointDetailPage', 'EndpointEditPage'],
            },
          ],
        },
        {
          action: 'fa-file-video',
          title: 'File Transcoding',
          projectCode: STORE_TYPES.PROJECT_CODE.FILE_TRANSCODING,
          active: true,
          items: [
            {
              title: 'Start New Job',
              action: 'add',
              route: 'FileTranscodingNewJobPage',
              components: ['FileTranscodingNewJobPage'],
            },
            {
              title: 'Dashboard',
              action: 'dashboard',
              route: 'FileTranscodingDashboard',
              components: ['FileTranscodingDashboard'],
            },
            {
              title: 'Jobs',
              action: 'view_list',
              route: 'FileTranscodingJobList',
              components: ['FileTranscodingJobList', 'FileTranscodingJobDetailPage'],
            },
            {
              title: 'Watch Folders',
              action: 'zmdi-folder-outline',
              route: 'WatchFolderListPage',
              components: [
                'WatchFolderListPage',
                'WatchFolderDetailPage',
                'WatchFolderNewPage',
              ],
            },
            {
              title: 'Encoding Profiles',
              action: 'assignment',
              route: 'EncodingProfileListPage',
              components: [
                'EncodingProfileListPage',
                'EncodingProfileNewPage',
                'EncodingProfileDetailPage',
                'EncodingProfileEditPage',
              ],
            },
          ],
        },
        {
          action: 'fa-play-circle',
          title: 'Live Transcoding',
          projectCode: STORE_TYPES.PROJECT_CODE.LIVE_TRANSCODING,
          items: [
            {
              title: 'Start New Stream',
              action: 'add',
              route: 'LiveTranscodingNewJobPage',
              components: ['LiveTranscodingNewJobPage'],
            },
            {
              title: 'Dashboard',
              action: 'dashboard',
              route: 'LiveTranscodingDashboard',
              components: [
                'LiveTranscodingDashboard',
                'LiveTranscodingJobDetailPage',
                'LiveTranscodingJobMetaPage',
                'LiveTranscodingJobEditPage',
              ],
            },
            {
              title: 'Distributions',
              action: 'fab fa-keycdn',
              route: 'DistributionListPage',
              components: [
                'DistributionListPage',
                'DistributionNewPage',
                'DistributionDetailPage',
                'DistributionEditPage',
              ],
            },
            {
              title: 'Encoding Profiles',
              action: 'assignment',
              route: 'LiveEncodingProfileListPage',
              components: [
                'LiveEncodingProfileListPage',
                'LiveEncodingProfileNewPage',
                'LiveEncodingProfileDetailPage',
                'LiveEncodingProfileEditPage',
              ],
            },
          ],
        },
        {
          action: 'fa-play-circle',
          title: 'DVR',
          projectCode: STORE_TYPES.PROJECT_CODE.DVR,
          items: [
            {
              title: 'Add New Record',
              action: 'add',
              route: 'DVRNewPage',
              components: ['DVRNewPage'],
            },
            {
              title: 'Recordings',
              action: 'view_list',
              route: 'DVRListPage',
              components: [
                'DVRListPage',
                'DVRDetailPage',
              ],
            },
          ],
        },
      ],
    };
  },
  computed: {
    currentProject() {
      return this.$store.getters.projectCode;
    },
    currentRoute() {
      return this.$route.name;
    },
    currentComponent() {
      switch (this.currentProject) {
        case STORE_TYPES.PROJECT_CODE.CDN:
          return 'CDNSidebar';
        case STORE_TYPES.PROJECT_CODE.FILE_TRANSCODING:
          return 'FileTranscodingSidebar';
        case STORE_TYPES.PROJECT_CODE.LIVE_TRANSCODING:
          return 'LiveTranscodingSidebar';
        default:
          return 'CDNSidebar';
      }
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  methods: {
    changeProject(index) {
      this.$store.dispatch('changeProject', projectIndex[index]);
      this.$router.push({ name: routes[index] });
    },
    linkClass(index) {
      return projectIndex[index] === this.currentProject ? 'link-active' : '';
    },
    goTo(route) {
      if (this.$route.name === route) return;
      this.$router.push({
        name: route,
      });
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return '';
    },
  },
};
</script>

<style>
  .link-active {
    color: #4272d7;
    font-weight: bold;
  }
  .pa2 {
    padding-left: 2px;
  }
</style>
